import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function ResetPass() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [err, setErr] = useState("");
    const [otp, setOtp] = useState("");
    const [page2, setPage2] = useState(false);
    const [page3, setPage3] = useState(false);
    const [newPass, setNewPass] = useState("");
    function handleClick() {
        if (email === "") {
            setErr("Please enter the email.");
            return;
        }
        if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
            setErr("Invalid Email.");
            return;
        }
        axios.post("https://newchatapp-mn65.onrender.com/verifymail", { email: email.toUpperCase() })
            .then((res) => {
                if (res.data.success) {

                    setPage2(true);
                }
            })
    }

    useEffect(() => {
        if (page2) {
            setTimeout(() => { setPage2(false) }, 300000);
        }
    }, [page2])


    function handleClk() {
        axios.post("https://newchatapp-mn65.onrender.com/otp", { otp })
            .then((res) => {
                if (res.data.message !== "User verified.") {
                    setErr("Wrong OTP");
                } else {
                    setPage3(true);
                    setPage2(false);
                }
            })
    }



    function handleClick3() {
        if (newPass == "") {
            setErr("Password field is empty");
            return;
        }
        axios.post("https://newchatapp-mn65.onrender.com/changepassword", { newPass, email })
            .then((res) => {
                if (res.data.success) {
                    navigate("../login", { replace: true })
                }
            })
    }

    if (page3) {
        return (
            <div className='register'>
                <h2>ChatApp</h2>
                <div className="registerform">
                    <label className='regisLabel' htmlFor="password">Set new password*</label>
                    <input name="newpass" onChange={(e) => { setNewPass(e.target.value) }} value={newPass} className='regisInput' title="This field is required" id='password' type="text" />
                    <button onClick={handleClick3} className='btnn'>Submit</button>
                </div>
                {err && <p className='regiserr'>{err} </p>}
            </div>
        )
    } else if (page2) {
        return (
            <div className="otpdiv">
                <div className="innerotpdiv">
                    <p>please check Email for OTP</p>
                    <p>OTP valid for 5 minutes</p>
                    <input autoFocus={true} onChange={(e) => { setErr(""); setOtp(e.target.value) }} type="text" value={otp} placeholder='Enter OTP' />
                    <button onClick={handleClk} className='sbtotp'>Submit</button>
                    {err && <p className='regiserr'>{err} </p>}
                </div>
            </div>
        )
    } else {
        return (
            <div className='register passresetpage'>
                <h2>ChatApp</h2>
                <div className="registerform passresetpageform">
                    <label className='regisLabel' htmlFor="email">Email</label>
                    <input name="email" onChange={(e) => { setErr(""); setEmail(e.target.value) }} value={email} autoFocus={true} className='regisInput resetpassinput' title="Please enter registered email" id='email' type="text" />
                    <small style={{ color: "#626168", fontWeight: "600" }}>Requires your primary ChatApp email address.</small>
                    <button onClick={handleClick} className='btnn'>Submit</button>
                </div>
                {err && <p className='regiserr'>{err} </p>}
                Already have login and password? <Link className='linktolog' style={{ textDecoration: "none", fontWeight: "600", margin: "0.6rem 0" }} to="/login">Sign in</Link>
            </div>

        )
    }

}

export default ResetPass

